import { IExecutiveSummary, IFiveWOneH } from './_models';

const formMeta = {
    formAction: '',
    iscompleted: false,
}

export const createExecutiveSummaryValues = (): IExecutiveSummary => ({
    project_overview: '',
    vision: '',
    opportunity_definition: '',
    ...formMeta,
});

export const normalizeExecutiveSummary = (data?: Partial<IExecutiveSummary>): IExecutiveSummary => ({
    ...createExecutiveSummaryValues(),
    project_overview: data?.project_overview || '',
    vision: data?.vision || '',
    opportunity_definition: data?.opportunity_definition || '',
    formAction: data?.formAction ?? '',
    iscompleted: data?.iscompleted ?? false,
});

export const createFiveWOneHValues = (): IFiveWOneH => ({
    ips_what: '',
    ips_why: '',
    ips_who: '',
    ips_where: '',
    ips_when: '',
    ips_how: '',
    ...formMeta,
});

export const normalizeFiveWOneH = (data?: Partial<IFiveWOneH>): IFiveWOneH => ({
    ...createFiveWOneHValues(),
    ips_what: data?.ips_what || '',
    ips_why: data?.ips_why || '',
    ips_who: data?.ips_who || '',
    ips_where: data?.ips_where || '',
    ips_when: data?.ips_when || '',
    ips_how: data?.ips_how || '',
    formAction: data?.formAction ?? '',
    iscompleted: data?.iscompleted ?? false,
});

export const projectInitiationDefaultValues = {
    project_overview: {
        project_id: 0,
        project_ref_no: '',
        name: '',
        short_name: '',
        department_id: 0,
        dept_programme_id: null,
        priority_id: '',
        desc: '',
        sector_id: 0,
        sub_sector_id: null,
        // location_id: null,
        district_id: null,
        municipality_id: null,
        jurisdiction_id: null,
        sector_action_id: null,
        project_lead: null,
        action_project_type_id: null,
        project_owner: null,
        project_manager: null,
        sector_name: '',
        department_name: '',
        project_type_data_key: [],
        sector_asset_type_id: [],
        idms_project_stage: '',
        implementation_timeframe: '',
        capax: '',
        opax: '',
        ballpark_project_cost: '',
        ...formMeta,
    },

    executive_summary: createExecutiveSummaryValues(),

    ex_5w1h: createFiveWOneHValues(),

    problem_identification: {
        current_state_description: '',
        cost_of_maintaining_status_quo: '',
        quantified_status_quo: '',
        with_project_scenario: '',
        desired_state_quantified: '',
        wcis_wciip_infrastructure_categories: [],
        wcis_wciip_infrastructure_categories_remarks: {},
        ...formMeta,
    },

    problem_tree_analysis: {
        focal_problem: '',
        consequences_if_problem_remains_unaddressed: '',
        comprehensive_problem_tree_narrative: '',
        solution_directions_high_level: [],
        solution_direction_narrative: '',
        ...formMeta,
    },

    evidence_base: {
        approved_data_sources: [],
        documents: [],
        ...formMeta,
    },

    with_project_scenario: {
        desired_state_description: '',
        desired_state_quantified: '',
        ...formMeta,
    },

    core_problem_and_gap_analysis: {
        core_problem_statement: '',
        cause_effect_logic: '',
        consequences: '',
        ...formMeta,
    },

    system_intelligence_layer: {},

    system_intelligence_layer_2: {},

    strategic_fit_summary_dashboard: {},

    sg0_key_activities_and_quests: {
        key_activities_and_quests: [],
        ...formMeta,
    },

    documents: {
        documents: [],
        ...formMeta,
    },

    key_business_drivers: {
        kbd_drivers_of_intervention_need: '',
        ...formMeta,
    },

    strategic_need: {
        strategic_need_narrative: '',
        public_value_proposition: '',
        citizen_impact: '',
        ...formMeta,
    },

    stakeholder_analysis_and_consultation: {
        stakeholder_validation: [],
        stakeholder_validation_remarks: {},
        beneficiary_groups: [],
        beneficiary_groups_remarks: {},
        institutional_sponsors: [],
        ...formMeta,
    },

    preliminary_procurement_strategy: {
        pps_major_inputs: [],
        major_inputs_cost_coverage_percent: '',
        proposed_procurement_methods: [],
        ppa_alignment: '',
        pfma_mfma_scm_compliance: '',
        nt_scm_notes_fidpm_guidance: '',
        procurement_risks: '',
        ...formMeta,
    },

    analysis_of_project_resource_requirements: {
        project_alternatives: [],
        sources_of_information: '',
        concept_report_preparation_plan: '',
        ...formMeta,
    },

    formulation_of_project_objectives_and_strategic_alignment: {
        project_objectives_areas: [],
        means_to_end_means: [],
        means_to_end_ends: [],
        project_outputs: [],
        project_outcomes: [],
        construction_jobs: '',
        permanent_jobs: '',
        temporary_jobs: '',
        smart_indicators: [],
        organisational_goals: [],
        policy_or_benchmark_alignment: [],
        implementation_link: '',
        strategic_alignment: '',
        simple_contribution_statement: '',
        alignment_strength: 0,
        oa_organisation_priorities_aspirations: '',
        oa_sector_development_plan: '',
        oa_other_development_strategies: '',
        ...formMeta,
    },

    approval_submit: {},

    constraints_and_risks: {
        constraints_and_risks: [],
        constraints_and_risks_remarks: {},
        ...formMeta
    },


    unique_value_proposition_and_competetive_advantage_or_investment_opportunity: {
        customer_segment: '',
        customer_need: '',
        unique_value_proposition: '',
        evidence_of_value: '',
        strategic_positioning: '',
        competitive_advantage: '',
        ...formMeta,
    },

    procurement_of_planning_resources: {
        request_for_additional_funding: '',
        ...formMeta,
    },
}

export type IProjectInitiationFormValues = typeof projectInitiationDefaultValues